/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_EDITPROFILEDATA, EDITPROFILEDATA_RECEIVED } = constants.EditProfileData;

export default {
  REQUEST_EDITPROFILEDATA,
  EDITPROFILEDATA_RECEIVED,

  requestEditProfileData: payload => ({
    type: REQUEST_EDITPROFILEDATA,
    payload
  }),
  EditProfileDataReceived: () => ({
    type: EDITPROFILEDATA_RECEIVED
  })
};
